import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { RolesService } from './roles.service';

@Injectable()
export class RoleGuard implements CanActivate {
  returnUrl: string;

  constructor(
    private authService: AuthService,
    private rolesService: RolesService,
    private router: Router
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const userRoleId: number = this.authService.getUserRole();
    const userRole = this.rolesService.getAccess(userRoleId);

    if (userRole) {
      if (userRole.routeAccess[state.url.split('/')[1]]) {
        return true;
      }
      console.warn('Access Denied. Navigated to default route');

      const defaultRoute = this.rolesService.getAccess(userRoleId).defaultRoute;
      this.router.navigate([`/${defaultRoute}`]);
      return false;
    } else {
      console.log(`User roles: [${userRole}] not recognized`);
      return false;
    }
  }
}
